import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  TextareaAutosize,
  TextField,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  DialogContentText,
  Link,
} from "@mui/material";
import SelectMaterial from "../../../component/Selectors/SelectMaterial";

const SelectMaterialDialog = ({ open, onClose, onSelect, onCancel }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      fullScreen={isSmallScreen}
      open={open}
      onClose={() => {
        onClose();
      }}
    >
      <DialogTitle>Select Material</DialogTitle>
      <DialogContent sx={{ minHeight: "300px" }}>
        <SelectMaterial
          value={null}
          onUpdate={(item) => {
            if (item) onSelect(item);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SelectMaterialDialog;
